import { Fragment } from "react";

import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { PageNavbar } from "@/pages/account";

import { useLayout } from "@/providers";

const Misc = () => {
  const { currentLayout } = useLayout();

  return (
    <Fragment>
      <PageNavbar />

      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle />
              <ToolbarDescription>This is page for Misc</ToolbarDescription>
            </ToolbarHeading>
          </Toolbar>
        </Container>
      )}
    </Fragment>
  );
};

export { Misc };
